// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TPublicOfferAcceptModel, IMappers, TPublicOfferAcceptResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { TPublicV1PublicOfferAcceptResponse } from '../../../entities/response/PublicV1PublicOfferAcceptResponse';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createPublicOfferAcceptModel(): TPublicOfferAcceptModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'dailyrent',
    pathApi: '/v1/public-offer/accept/',
    response: {
      '200': {
        contentType: 'json',
      },
      '400': {
        contentType: 'json',
      },
    },
  };
}

export interface IPublicOfferAcceptOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchPublicOfferAccept<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IPublicOfferAcceptOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TPublicOfferAcceptResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createPublicOfferAcceptModel(),
    config,
  )) as FetchResponse<TPublicOfferAcceptResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TPublicV1PublicOfferAcceptResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TPublicOfferAcceptResponse>;
}
